<!-- 图片广告 -->
<template>
    <div v-if="componentsData.type == 5" :style="`padding: ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px;background: ${bg_color};`">
        <div :style="`height: ${componentsData.content.height}px;`">
            <imageStyle class="h100" :imageData="componentsData"></imageStyle>
        </div>
    </div>
</template>

<script>
import imageStyle from "@/components/imgStyle/imageStyle.vue";
export default {
    components: {
        imageStyle,
    },
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
        bg_color: {
            type: String,
            default: "#fff",
        },
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
    },
};
</script>

<style scoped>
.h100 {
    height: 100%;
}
</style>